import React, { ReactNode } from 'react'
import styled from '@emotion/styled'

const Container = styled.h1<{ fontSize?: number; lineHeight?: number }>`
  margin: 0;
  padding: 0;

  font-family: 'Nunito';
  font-weight: 600;
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '15px')};
  line-height: ${(props) =>
    props.lineHeight ? `${props.lineHeight}px` : '11px'};
  font-style: normal;
  text-align: center;

  color: #000000;
`

type HeaderProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
> & {
  children: ReactNode
  fontSize?: number
  lineHeight?: number
}

export function Header({
  children,
  ...props
}: HeaderProps): React.ReactElement {
  return <Container {...props}>{children}</Container>
}
